import React from "react";
import Marquee from "react-fast-marquee";
import { motion } from "framer-motion";
import { BRAND, IMAGES } from "../../lib/brand";
import { Phone, ArrowRight, Star } from "lucide-react";

export const Hero = ({ stats }) => {
  return (
    <section id="top" className="relative overflow-hidden bg-[#0a0a0a] grain">
      <div
        className="absolute inset-0 opacity-20 bg-cover bg-center"
        style={{ backgroundImage: `url(${IMAGES.heroTexture})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/70 to-black" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 pt-16 pb-12 lg:pt-24 lg:pb-20 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="inline-flex items-center gap-2 border-2 border-[#7CB518] px-3 py-1 mb-6"
          >
            <span className="w-2 h-2 bg-[#7CB518] animate-pulse" />
            <span className="text-xs uppercase tracking-[0.2em] text-[#7CB518]">
              Based in Central Alberta
            </span>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.55, delay: 0.05 }}
            className="font-display uppercase text-6xl md:text-8xl leading-[0.85] tracking-tighter"
          >
            We Haul<br />
            Your <span className="text-[#7CB518]">Junk</span><br />
            Away.
          </motion.h1>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="mt-6 text-base md:text-lg text-white/70 max-w-xl"
          >
            Fast, no-nonsense junk removal serving the Central Alberta area.
            Give us a call, we show up, it's gone. Simple.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="mt-8 flex flex-wrap gap-4"
          >
            <a
              href="#contact"
              data-testid="hero-quote-btn"
              className="press inline-flex items-center gap-2 bg-[#7CB518] text-black font-display uppercase text-lg px-8 py-4 border-2 border-[#7CB518] hard-shadow-white"
            >
              Get A Free Quote <ArrowRight size={20} />
            </a>
            <a
              href={BRAND.phoneHref}
              data-testid="hero-call-btn"
              className="press inline-flex items-center gap-2 bg-transparent text-white font-display uppercase text-lg px-8 py-4 border-2 border-white hard-shadow"
            >
              <Phone size={18} /> {BRAND.phone}
            </a>
          </motion.div>

          <div className="mt-10 flex flex-wrap gap-8">
            <div>
              <div className="font-display text-4xl text-[#7CB518] flex items-center gap-1">
                {stats?.avg_rating ?? "5.0"} <Star size={22} fill="#7CB518" stroke="#7CB518" />
              </div>
              <div className="text-xs uppercase tracking-[0.2em] text-white/50">Avg Rating</div>
            </div>
            <div>
              <div className="font-display text-4xl text-[#7CB518]">FREE</div>
              <div className="text-xs uppercase tracking-[0.2em] text-white/50">Quotes</div>
            </div>
            <div>
              <div className="font-display text-4xl text-[#7CB518]">LOCAL</div>
              <div className="text-xs uppercase tracking-[0.2em] text-white/50">Central Alberta</div>
            </div>
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="lg:col-span-5 flex justify-center"
        >
          <img
            src={IMAGES.logo}
            alt={BRAND.name}
            className="w-full max-w-md drop-shadow-[0_0_40px_rgba(124,181,24,0.25)]"
          />
        </motion.div>
      </div>

      <div className="relative z-10 caution-tape border-y-4 border-black py-3">
        <Marquee speed={60} gradient={false}>
          {["NO DIRT / SOIL", "NO BIG DEMO JOBS", "SAME-WEEK PICKUPS", "WE SWEEP UP AFTER", "FREE QUOTES"].map((t, i) => (
            <span key={i} className="font-display uppercase text-2xl text-black bg-[#7CB518] px-6 mx-1 py-1">
              {t}
            </span>
          ))}
        </Marquee>
      </div>
    </section>
  );
};
